<template>
    <layout>
        <template slot="title">
            <img height="45px" src="/logo.png" alt="logo" :title="trans('layout.title')" />
        </template>
        <template slot="header">
            <select-locale class="mx-2"></select-locale>
        </template>
        <slot></slot>
        <template slot="footer">
            {{trans('layout.footer')}}
        </template>
    </layout>
</template>
<script>
import AppLayout from "./layout/AppLayout";
import SelectLocale from "./SelectLocale";

export default {
    props: {},
    data() {
        return {};
    },
    computed: {},
    methods: {},
    watch: {},
    filters: {},
    components:{
        SelectLocale,
        layout:AppLayout,
    }
}
</script>
